import React from 'react';
import ArtemisUniqueness from '../artemis/ArtemisUniqueness';
import ArtemisIntelligenceDiagram from '../artemis/ArtemisIntelligence';
import MultiObjectiveOptimisation from '../artemis/MultiObjectiveOptimisation';

const EvolutionaryApproach = () => {
  const [activeView, setActiveView] = React.useState('uniqueness');

  return (
    <div style={{
      height: '100vh',
      background: 'linear-gradient(135deg, #0F2027 0%, #203A43 50%, #2C5364 100%)',
      display: 'flex',
      flexDirection: 'column',
      color: 'white',
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
      overflow: 'hidden'
    }}>
      {/* Header */}
      <div style={{
        padding: '20px 30px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        background: 'rgba(0, 0, 0, 0.3)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h1 style={{ 
              margin: 0, 
              fontSize: '28px',
              fontWeight: '700',
              background: 'linear-gradient(135deg, #667eea, #764ba2)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
              🧬 Evolutionary Approach
            </h1>
            <p style={{ margin: '5px 0 0 0', fontSize: '14px', opacity: 0.8 }}>
              AI-Driven Evolution: Multiple Agents Compete and Evolve to Find Optimal Solutions
            </p>
          </div>
          
          {/* View Selector */}
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', maxWidth: '600px' }}>
            <button
              onClick={() => setActiveView('uniqueness')}
              style={{
                padding: '8px 20px',
                background: activeView === 'uniqueness' ? 
                  'linear-gradient(135deg, #667eea, #764ba2)' : 
                  'rgba(255, 255, 255, 0.1)',
                border: 'none',
                borderRadius: '20px',
                color: 'white',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.3s ease'
              }}
            >
              🚀 Artemis Uniqueness
            </button>
            <button
              onClick={() => setActiveView('intelligence')}
              style={{
                padding: '8px 20px',
                background: activeView === 'intelligence' ? 
                  'linear-gradient(135deg, #667eea, #764ba2)' : 
                  'rgba(255, 255, 255, 0.1)',
                border: 'none',
                borderRadius: '20px',
                color: 'white',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.3s ease'
              }}
            >
              🧠 Genetic Algorithm
            </button>
            <button
              onClick={() => setActiveView('optimization')}
              style={{
                padding: '8px 20px',
                background: activeView === 'optimization' ? 
                  'linear-gradient(135deg, #667eea, #764ba2)' : 
                  'rgba(255, 255, 255, 0.1)',
                border: 'none',
                borderRadius: '20px',
                color: 'white',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.3s ease'
              }}
            >
              🎯 Multi-Objective
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
        {/* Content Area */}
        <div style={{
          flex: 1,
          background: 'rgba(255, 255, 255, 0.98)',
          margin: '20px',
          borderRadius: '12px',
          overflow: 'hidden',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)'
        }}>
          {activeView === 'uniqueness' && <ArtemisUniqueness />}
          {activeView === 'intelligence' && (
            <div style={{ height: '100%', width: '100%' }}>
              <ArtemisIntelligenceDiagram title="Genetic Algorithm Evolution: How AI Agents Evolve Better Solutions" />
            </div>
          )}
          {activeView === 'optimization' && (
            <div style={{ height: '100%', width: '100%' }}>
              <MultiObjectiveOptimisation title="Multi-Objective Optimization: Balancing Performance, Memory & Readability" />
            </div>
          )}
        </div>
      </div>

      {/* Bottom Info Bar */}
      <div style={{
        padding: '15px 30px',
        background: 'rgba(0, 0, 0, 0.3)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        display: 'flex',
        justifyContent: 'center',
        gap: '30px'
      }}>
        <div style={{ fontSize: '13px', opacity: 0.8 }}>
          <span style={{ color: '#667eea', fontWeight: '600' }}>🧬 Self-Improving AI</span> • 
          <span style={{ marginLeft: '8px' }}>Evolves better solutions over time</span>
        </div>
        <div style={{ fontSize: '13px', opacity: 0.8 }}>
          <span style={{ color: '#764ba2', fontWeight: '600' }}>🤖 Multi-Agent Competition</span> • 
          <span style={{ marginLeft: '8px' }}>Best ideas survive and breed</span>
        </div>
        <div style={{ fontSize: '13px', opacity: 0.8 }}>
          <span style={{ color: '#52B69A', fontWeight: '600' }}>📊 Pareto Optimization</span> • 
          <span style={{ marginLeft: '8px' }}>Balance multiple objectives</span>
        </div>
      </div>
    </div>
  );
};

export default EvolutionaryApproach; 